<template>

  <div class="notifications-module-root">
    <ba-header :disableMenu="true" activeModule="Notifications"></ba-header>

    <ba-page-with-sidebar :title="'Notifications'">
      <template slot="main">
        <h3 class="u-pt5 c-heading__page u-pb3">Notifications</h3>

        <div class="company u-mt4" v-for="company in allNotifications" v-if="company.notifications.length > 0">
          <h3>{{company.name}}</h3>
          <div class="company-notifications" v-for="notification in company.notifications">
            <div class="el-card u-mt4 ">

              <div class="notification__type" :class="classFromEventType(notification)">
                <icon name="warning" scale="0.75"></icon> {{eventTypeToDescription(notification.event_type)}}
              </div>
              <div class="notification__url u-mt4">
                <a :href="company.site_full_url" target="_blank" title="Will open in new tab">{{company.site_full_url}}</a>
              </div>
              <div class="notification__since u-mt3">

                {{notification.since | moment('from', new Date())}} <span class="u-text--sm u-text--light">({{notification.since | moment('YYYY-MM-DD HH:mm:ss')}})</span>
              </div>
              <el-collapse class="u-mt4">
                <div>
                  <el-collapse-item title="Show details">
                    <el-row>
                      <div class="notification__details">
                        {{notification.details}}
                      </div>
                    </el-row>
                  </el-collapse-item>
                </div>
              </el-collapse>


            </div>
          </div>

        </div>

      </template>
    </ba-page-with-sidebar>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import BaPageWithSidebar from '@/components/page-with-sidebar.component'

  export default {
    components: {
      BaPageWithSidebar,
    },
    data () {
      this.loadAllNotifications()
      return {}
    },
    computed: {
      ...mapState('shared', ['allNotifications'])
    },
    methods: {
      ...mapActions('shared', ['loadAllNotifications']),
      eventTypeToDescription (eventType) {
        if (eventType === 'desktop_portal.down') {
          return 'Site is not available'
        }
        return eventType
      },
      classFromEventType (notification) {
        if (notification.event_severity === 'critical') {
          return 'u-text--danger'
        }
      }
    },
    name: 'notification-page'
  }
</script>

<style scoped>
 .notification__details {
   white-space: pre-line;
 }
</style>